export default __webpack_public_path__ + "fonts/MacQuayDesign_LongReport_rev_0.pdf";